import { Array } from "@siteimprove/alfa-array";
import { Performance as alfaPerformance } from "@siteimprove/alfa-performance";
const { isMeasure } = alfaPerformance.Measure;
/**
 * Record various durations in an audit.
 *
 * @public
 */
export var Performance;
(function (Performance) {
    const commonKeys = ["cascade", "aria-tree", "total"];
    /** @internal */
    function empty() {
        return { cascade: 0, "aria-tree": 0, total: 0 };
    }
    Performance.empty = empty;
    /** @internal */
    function recordCommon(durations) {
        return alfaPerformance.of().on((entry) => {
            if (isMeasure(entry) && Array.includes(commonKeys, entry.data)) {
                // Type is ensured by the previous check
                durations[entry.data] = entry.duration;
            }
        });
    }
    Performance.recordCommon = recordCommon;
})(Performance || (Performance = {}));
//# sourceMappingURL=performance.js.map